var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.99 511.99",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.005119920000000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fed6cd"
    },
    d: "M460.403,386.243l-1.812-0.531c-26.5-7.125-35.469-13.953-47.25-18.438 c-41.843-15.938-52.717-27.436-55.498-32.857c-0.109-0.203-0.188-0.406-0.281-0.609l-0.344-48.594L256,284.09l-99.225,1.125 l-0.344,48.594c-0.086,0.203-0.164,0.406-0.266,0.609c-2.781,5.422-13.672,16.92-55.508,32.857 c-11.796,4.484-20.757,11.312-47.248,18.438l-1.82,0.531c-24.117,7.969-40.344,30.328-40.344,55.562v70.186h244.754h244.747v-70.186 C500.746,416.572,484.527,394.213,460.403,386.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M393.684,191.184c0,89.467-85.278,171.778-137.685,171.778c-52.397,0-137.678-82.311-137.678-171.778 c0-89.459,61.64-148.482,137.678-148.482C332.03,42.702,393.684,101.724,393.684,191.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143666"
    },
    d: "M383.872,63.577H127.885c-5.898,0-10.68,4.773-10.68,10.672v85.413c0,4.898,3.328,9.164,8.07,10.352 c1.789,0.453,44.727,11,130.725,11c85.999,0,128.716-10.547,130.481-11c4.734-1.195,8.062-5.461,8.062-10.352V74.248 C394.544,68.351,389.763,63.577,383.872,63.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#346ab7"
    },
    d: "M482.215,42.89L258.008,0.188c-1.32-0.25-2.672-0.25-3.992,0L29.808,42.89 c-5.039,0.961-8.68,5.367-8.68,10.492s3.641,9.523,8.68,10.484l224.207,42.71c0.656,0.125,1.328,0.188,1.992,0.188 c0.672,0,1.344-0.062,2-0.188l224.207-42.71c5.031-0.961,8.688-5.359,8.688-10.484C490.902,48.257,487.246,43.85,482.215,42.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#619eff"
    },
    d: "M480.215,138.309c-5.891,0-10.671-4.781-10.671-10.679V53.382c0-5.898,4.78-10.68,10.671-10.68 c5.906,0,10.688,4.781,10.688,10.68v74.249C490.902,133.529,486.121,138.309,480.215,138.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee6d6d"
    },
    d: "M460.403,386.243l-1.812-0.531c-26.5-7.125-35.469-13.953-47.25-18.438 c-16.422-6.25-28.062-11.828-36.344-16.625L256,437.243l-118.717-86.75c-8.281,4.812-20.008,10.438-36.625,16.781 c-11.796,4.484-20.757,11.312-47.248,18.438l-1.82,0.531c-24.117,7.969-40.344,30.328-40.344,55.562v70.186H256h244.746v-70.186 C500.746,416.572,484.527,394.213,460.403,386.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#619eff"
    },
    d: "M480.215,64.053h-224.34c-5.898,0-10.68-4.781-10.68-10.671c0-5.898,4.781-10.68,10.68-10.68h224.34 c5.906,0,10.688,4.781,10.688,10.68C490.902,59.272,486.121,64.053,480.215,64.053z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo05);
export default __webpack_public_path__ + "static/media/logo05.cd6f7a0a9c25512a2c27f572768e982e.svg";
export { ForwardRef as ReactComponent };